import axios from "axios";
import {
  GETSHEDULEMEETING,
  CREATESHEDULEMEETING,
  baseURL,
} from "./type";

export const createshedulemeeting = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "post",
     url: baseURL + "/api/electionmeetings/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type:   CREATESHEDULEMEETING,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getshedulemeeting = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    // url: baseURL + "setupElectionTypes/getAll",
     url: baseURL + "/api/electionmeetings/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSHEDULEMEETING,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};